import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  truncatedText: {
    cursor: 'pointer'
  },
  tooltipLabel: {
    width: '100%'
  },
  tooltip: {
    backgroundColor: theme.colors.tooltip_background
  },
  tooltipList: {
    margin: 0,
    paddingLeft: theme.spacing(2)
  }
}));

export default useStyles;
